(function () {
  'use strict';

  angular.module('mobile.lead.add').config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider.state('mobile', {
      url: '/mobile',
      template: require('../mobile.lead.add/mobile.lead.add.html'),
      controller: 'MobileLeadAddCtrl',
      controllerAs: 'vm',
    });
  }
})();
